import { render, staticRenderFns } from "./tabCommerceResponsiblePerson.vue?vue&type=template&id=066cb180&scoped=true&"
import script from "./tabCommerceResponsiblePerson.vue?vue&type=script&lang=js&"
export * from "./tabCommerceResponsiblePerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066cb180",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('066cb180')) {
      api.createRecord('066cb180', component.options)
    } else {
      api.reload('066cb180', component.options)
    }
    module.hot.accept("./tabCommerceResponsiblePerson.vue?vue&type=template&id=066cb180&scoped=true&", function () {
      api.rerender('066cb180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/tabCommerceResponsiblePerson.vue"
export default component.exports